module.exports = __webpack_public_path__ + "static/media/antigua-historic-1.3b4ac8b1.jpg";